<template>
  <div class="user">
    <div class="" v-loading="loading">
      <div class="s_wrapper">
        <el-input class="s_input" v-model="orderNum" placeholder="请输入订单编号" suffix-icon="el-icon-search"
          @change="onSearch" clearable></el-input>
        <el-input class="s_input" v-model="parentName" placeholder="请输入大团长名称" suffix-icon="el-icon-search"
          @change="onSearch" clearable></el-input>
        <el-input class="s_input" v-model="userName" placeholder="请输入下级用户名称" suffix-icon="el-icon-search"
          @change="onSearch" clearable></el-input>
      </div>

      <div class="g_table">
        <el-table :data="tableData" style="width: 100%" max-height="540">
          <el-table-column label="序号" show-overflow-tooltip width="100">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column min-width="130" show-overflow-tooltip prop="orderNum" label="订单编号"></el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="bizName" label="订单名称"></el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="orderType" label="订单类型">
            <template slot-scope="scope">
              <span v-if="scope.row.orderType == 1">课程</span>
              <span v-if="scope.row.orderType == 2">直播</span>
              <span v-if="scope.row.orderType == 3">游学活动</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="saleType" label="结算类型">
            <template slot-scope="scope">
              <span v-if="scope.row.saleType == 1">销售</span>
              <span v-if="scope.row.saleType == 2">退款</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="parentName" label="大团长名称"></el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="userName" label="下级用户名称"></el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="payAmount" label="订单金额(元)"></el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="commissionRatio"
            label="提成比例(%)"></el-table-column>
          <el-table-column min-width="130" show-overflow-tooltip prop="commissionAmount" label="提成金额">
            <template slot-scope="scope">
              <div>
                <span style="margin-right: 1px;" v-if="scope.row.saleType == 2">-</span>
                {{ scope.row.commissionAmount }}
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="payTime" label="支付时间"></el-table-column>
        </el-table>
      </div>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalCount"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      parentName: "",//大团长
      userName: "",//下级用户
      orderNum: "",//订单编号
      tableData: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getRequestList()
  },
  methods: {
    getRequestList() {
      this.loading = true
      this.$axios
        .get(this.$api.revenueList, {
          params: {
            parentName: this.parentName || null,
            userName: this.userName || null,
            orderNum: this.orderNum || null,
            dateType: null,//日期类型：1：今天 2：本周 3本月
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          this.tableData = res.result.list
          this.totalCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    // 搜索
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getRequestList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getRequestList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getRequestList()
    },
  },
}
</script>

<style scoped lang="scss">
.user {
  .disabled_user_account {
    width: 255px;
    color: #c0c4cc;
    padding: 0 15px;
    border-radius: 10px;
    background-color: #f5f7fa;
    box-sizing: border-box;
    cursor: not-allowed;
  }
}
</style>
